var React = require('react');

function CardsInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"0.615696","y":"0.885323","width":"10.6166","height":"13.6668","rx":"2.25","transform":"matrix(0.981131 0.193346 -0.160203 0.987084 6.58314 -0.107608)","fill":"none","stroke":"#606A81","strokeWidth":"1.5","key":0}),React.createElement("rect",{"x":"0.5","y":"4.5","width":"13","height":"16","rx":"3.5","fill":"none","stroke":"none","key":1}),React.createElement("rect",{"x":"1.75","y":"5.75","width":"10.5","height":"13.5","rx":"2.25","fill":"none","stroke":"#606A81","strokeWidth":"1.5","key":2})]);
}

CardsInline.defaultProps = {"width":"19","height":"21","viewBox":"0 0 19 21","fill":"none"};

module.exports = CardsInline;

CardsInline.default = CardsInline;
